export const toSelectOption = (data) => {
  if (!data || data === 'Error') return data;

  return data.map((city) => ({
    key: city.id,
    value: city,
    content: city.name,
    search: city.name,
  }));
};
